import React from "react";
import { Link } from "react-router-dom";
import { Layers } from "lucide-react";
import { formatAiCredits } from "@/lib/formatAiCredits";
import { computePoolUsagePercent } from "@/constants/partnerPoolContent";

const PartnerPoolKpi = ({ pool }) => {
  const used = pool.used ?? 0;
  const included = pool.included ?? 0;
  const percent =
    pool.usagePercent != null
      ? pool.usagePercent
      : computePoolUsagePercent(used, included);

  return (
    <div
      className="mb-8 rounded-2xl border border-[#00D2FF]/20 bg-[#00D2FF]/5 p-5 md:p-6"
      data-testid="partner-pool-kpi"
    >
      <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div className="flex items-start gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#00D2FF]/10 border border-[#00D2FF]/20">
            <Layers className="h-5 w-5 text-partner-accent" />
          </div>
          <div>
            <div className="flex items-center gap-2 flex-wrap">
              <p className="text-xs font-mono uppercase tracking-wider text-partner-muted">
                Agency credit pool
              </p>
              {pool.trackingLive === false && (
                <span className="text-[10px] font-mono px-2 py-0.5 rounded-full bg-amber-500/10 text-amber-400 border border-amber-500/30">
                  Demo pool · live tracking Phase 2
                </span>
              )}
            </div>
            <p className="text-2xl font-heading font-bold text-partner mt-1">
              {formatAiCredits(used)} / {formatAiCredits(included)}
            </p>
            <p className="text-sm text-partner-muted font-body mt-1">
              Pooled across {pool.clientCount ?? 0} clients · {percent}% consumed
            </p>
          </div>
        </div>
        <div className="w-full lg:w-56">
          <div className="h-2 rounded-full bg-[#080A0F] overflow-hidden">
            <div
              className={`h-full rounded-full ${
                percent >= 100 ? "bg-red-400" : percent >= 80 ? "bg-amber-400" : "bg-[#00D2FF]"
              }`}
              style={{ width: `${Math.min(percent, 100)}%` }}
            />
          </div>
          <Link
            to="/partner/clients"
            className="mt-3 inline-block text-xs font-body text-partner-accent hover:underline"
          >
            Upgrade client tier for more credits
          </Link>
        </div>
      </div>
    </div>
  );
};

export default PartnerPoolKpi;
